import {
  ClipboardList,
  Dumbbell,
  Truck,
  Wrench,
  LifeBuoy,
  TrendingUp,
} from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import { SERVICES } from "./data";

const ICONS = { ClipboardList, Dumbbell, Truck, Wrench, LifeBuoy, TrendingUp };

export default function Services() {
  return (
    <section id="services" className="relative bg-coal py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="mb-14 max-w-3xl">
          <Eyebrow>Services</Eyebrow>
          <SectionTitle>
            More Than Equipment. <span className="text-edge">A Complete Fitness Solution.</span>
          </SectionTitle>
        </Reveal>

        <div className="grid gap-px border border-line bg-line sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.title} delay={i * 0.06} className="h-full">
                <div
                  className="group relative flex h-full flex-col overflow-hidden bg-coal p-8 transition-colors duration-300 hover:bg-card"
                  data-testid={`service-card-${i + 1}`}
                >
                  <span
                    className="absolute -right-3 -top-5 font-display text-8xl font-black text-white/[0.04] transition-colors duration-300 group-hover:text-edge/10"
                    aria-hidden="true"
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <Icon
                    size={26}
                    strokeWidth={1.6}
                    className="mb-6 text-edge transition-transform duration-300 group-hover:-translate-y-1"
                  />
                  <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-white">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-ash">{s.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
